module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('em', [_c('strong', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/halftitle2#halftitle"
    }
  }, [_vm._v("After Fukushima: The Equivalence of Catastrophes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/preamble#preamble"
    }
  }, [_vm._v("Preamble")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 1")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 2")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 3")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 4")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 5")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 6")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 7")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 8")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 9")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/question#question",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions for Jean-Luc Nancy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_vm._v("Yuji Nishiyama and Yotetsu Tonaki")]), _vm._v(" "), _c('p', {
    staticClass: "tocchapa"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/catastro#catastro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s a Catastrophe! Interview with Jean-Luc Nancy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_vm._v("Danielle Cohen-Levinas")]), _vm._v(" "), _c('p', {
    staticClass: "tocchap2"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0